import React from 'react'
import "./style.css"
export default (props)=>{
  return (
    <div className="spinner">
  <div className="bounce1"></div>
  <div className="bounce2"></div>
  <div className="bounce3"></div>
</div>
  )
}



// WEBPACK FOOTER //
// ./src/components/shared/loading/index.js